import { For, Stack } from '@chakra-ui/react';

import type { SavedJobListItemVM } from '@/modules/job/view-models';

import { JobCardSaved } from '../JobCardSaved/SavedJobCard';

export type SavedJobListProps = {
	interestedJobs: SavedJobListItemVM[]
	isLoading:      boolean

	onClickDelete?: (jobId: string) => void
};

export const SavedJobList = ({ interestedJobs, isLoading, onClickDelete }: SavedJobListProps) => {
	if (isLoading) {
		return <div>Loading...</div>;
	}

	if (interestedJobs.length === 0) {
		return <div>No interested jobs found.</div>;
	}

	return (
		<Stack gap={6}>
			<For each={interestedJobs}>
				{interestedJob => (
					<JobCardSaved
						interestedJob={interestedJob}
						key={interestedJob.id}
						onClickDelete={() => onClickDelete?.(interestedJob.id)}
						status={interestedJob.status as 'closed'}
					/>
				)}
			</For>
		</Stack>
	);
};
